'use client';

import { useTranslations } from 'next-intl';
import { HeaderStoreLocationButton } from 'components/pcc-components';
import { useStoreInfoDrawer } from '../../store-info-drawer-context';
import { useAssociatedDealer } from 'components/associated-dealers/associated-dealer-context';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';

interface StoreLocationButtonProps {
  isLoggedIn: boolean;
}

export const StoreLocationButton = ({
  isLoggedIn
}: StoreLocationButtonProps) => {
  const t = useTranslations();
  const storeInfoDrawer = useStoreInfoDrawer();
  const { associatedDealerDrawer } = useAssociatedDealer();
  const dealerLocatorDrawer = useDealerLocatorDrawer();
  const changeLocationLabel = t('MA_DROPDOWN_IA_CHANGE_STORE');

  const handleClick = () => {
    storeInfoDrawer.closeDrawer();
    isLoggedIn
      ? associatedDealerDrawer.openDrawer()
      : dealerLocatorDrawer.openDrawer();
  };

  return (
    <HeaderStoreLocationButton
      label={changeLocationLabel}
      onClick={handleClick}
    />
  );
};
